import styled from 'styled-components';

export const SActions = styled.div`
  display: flex;
  justify-content: end;
  align-items: center;
`;

export const SDivider = styled.div`
  width: 2px;
  height: 50px;

  margin-left: 20px;
  margin-right: 20px;

  border-radius: 1px;
  background-color: ${({ theme }) => theme.colors.quaternaryBackground};
`;

export const SExport = styled.div`
  height: 50px;
  width: 50px;

  display: flex;
  justify-content: center;
  align-items: center;

  border-radius: 5px;
  background-color: ${({ theme }) => theme.colors.quaternaryBackground};
  color: ${({ theme }) => theme.colors.primaryText};
`;

interface ITabProps {
  active?: boolean;
}

export const STab = styled.div<ITabProps>`
  display: flex;
  padding: 16px;
  background-color: ${({ theme }) => theme.colors.quaternaryBackground};

  ${({ active, theme }) =>
    active &&
    `
        background-color: ${theme.colors.primary};`}
`;

export const STabContainer = styled.div`
  display: flex;
  border-radius: 5px;
  overflow: hidden;
`;

export const STabIcon = styled.i`
  margin-right: 16px;
`;

export const STitle = styled.div`
  font-size: 30px;
  font-weight: 600;
  font-family: ${({ theme }) => theme.fonts.semiBold};
  color: ${({ theme }) => theme.colors.primaryText};
`;

export const STitleCount = styled.div`
  margin-left: 10px;
  font-size: 17.5px;
  font-weight: 600;
  color: ${({ theme }) => theme.colors.quinaryText};
`;

export const SWrapper = styled.div`
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
`;

export const SDatePickerWrapper = styled.div`
  width: 200px;
  display: inline-block;
`;

// export const SDatePickerLabel = styled.div`
//   width: 60px;
//   margin-right: 10px;
//   display: inline-block;
// `;

export const SDatePickerLabel = styled.label`
  margin-bottom: 5px;
  font-size: 10px;
  font-weight: 500;
  letter-spacing: 0.1px;
  font-family: ${({ theme }) => theme.fonts.medium};
  color: ${({ theme }) => theme.colors.tertiaryText};
`;

export const SDatePicker = styled.div`
  width: 100px;
  margin-right: 10px;
  display: inline-block;
`;

export const SClearDatePickerButton = styled.div`
  width: 100px;
  height: 25px;
  float: left;
  padding-left: 85px;
  position: relative;
  margin-top: -30px;
`;

export const SActiveOnDatePicker = styled.div`
  .k-datepicker {
    width: 140px;
    align-items: center;
    background-color: white !important;
    border-radius: 0.156rem;
    border: none;
    display: flex;
    font-family: ${({ theme }) => theme.fonts.regular};
    font-size: 12.5px;
    height: 35px;
    letter-spacing: 0px;
    outline: none;
    transition: box-shadow 0.3s linear;

    &:hover {
      box-shadow: ${({ theme }) => `0 0 0 2px ${theme.colors.icon}`};
    }

    &:focus {
      box-shadow: ${({ theme }) => `0 0 0 1px ${theme.colors.icon}`};
    }
  }

  .k-datepicker:focus {
    border: 1px solid ${({ theme }) => theme.colors.icon} !important;
  }

  .k-input-inner {
    padding-left: 10px;
    height: 35px;
  }

  .k-input-solid {
    border-radius: 0.156rem !important;
  }

  .k-input-button {
    height: 35px;
    width: 35px;
    font-size: 12px;
    background-color: ${({ theme }) => theme.colors.quaternaryBackground};
    color: ${({ theme }) => theme.colors.primaryText};
  }

  /* Prevents all mouse interactions in the date input textbox. */
  .k-select,
  .k-dateinput,
  .k-input-inner {
    pointer-events: none;
  }

  /* Prevents all other focus events in the date input textbox.
  Flickers slightly when it receives focus but there are no css alternatives. */
  .k-dateinput:focus,
  .k-dateinput:focus-within {
    visibility: hidden;
  }
`;
